import { appMethod as app } from '@utils/app';
import { getCurrentPageQueryParams, convertLineStyleData } from '@utils/tools';
import { TopNav } from '@common/top-nav/TopNav';
import OfficialPage from '../OfficialPage';

import './ShareGifts.less';

export default class ShareGifts extends OfficialPage {
  state = {
    is_select: false,
    is_over: false,
    isMultiple: false,
    rebateNum: 0,
    activity_rewards: {},
    extra_times_limit: {},
    times_limit: {},
    recv_limit: 0,
    type: '',
    surplus_times: 0
  }

  constructor(props) {
    super(props);
    document.title = '分享有礼';
  }

  componentWillMount(options = getCurrentPageQueryParams()) {
    this.setData({
      ids: options.ids || '',
      extraIds: options.extraIds || ''
    })
    this.getEffectActivity()
    this.getRewards(true)
  }

  getEffectActivity = () => {
    var that = this,
      type = ''
    app.sendRequest({
      url: '/index.php?r=ShareGiftActivity/GetEffectActivity',
      success: function (res) {
        let data = res.data
        that.setData({
          rebateNum: 0,
          description: data.description,
          activity_rewards: data.extra_rewards,
          times_limit: data.times_limit,
          extra_times_limit: data.extra_times_limit,
          recv_limit: data.recv_limit,
          type: data.immediately,
          surplus_times: data.surplus_times,
          immediately: data.immediately
        })
      }
    })
  }
  getRewards = isInit => {
    let that = this
    app.sendRequest({
      url: '/index.php?r=ShareGiftActivity/CanRecvRewards',
      data: {
        appoint_ids: that.data.ids,
        extra_appoint_ids: that.data.extraIds
      },
      success: function (res) {
        if (res.data) {
          let data = res.data
          let extra = data.extra_rewards[0] || ''
          if (extra) {
            extra = that.typeClassify(extra.type, extra)
          }
          for (var index in data.rewards) {
            let g = data.rewards[index]
            g = that.typeClassify(g.type, g)
          }
          that.setData({
            extra_rewards: extra
          })
          that.loadRewards(isInit, data)
        }
      }
    })
  }
  loadRewards = (isInit, data) => {
    let that = this,
      gifts = data.rewards || [],
      giftsLen = gifts.length,
      recv_chance = data.recv_chance,
      recv_limit = data.recv_limit,
      share_persons = data.share_persons,
      isMultiple = that.data.isMultiple,
      giftsModal
    if (isInit) {
      if (recv_chance > 1 && recv_limit == 1 && giftsLen > 1) {
        isMultiple = true
      }
    }
    for (var index in gifts) {
      let f = gifts[index]
      f.times = 0
      f.is_select = false
      if (isInit) {
        gifts[index].giftsModal =
          recv_limit == 0 || gifts.length == 1
            ? '0'
            : recv_chance > 1
              ? '2'
              : '1'
        gifts[index].is_select = false
        if (gifts[index].type == 1) {
          if (gifts[index].stock == 0) {
            gifts[index].is_hide = true
          } else {
            gifts[index].is_hide = false
          }
        }
      } else {
        gifts[index].giftsModal = that.data.gifts[index].giftsModal
        gifts[index].is_select = that.data.gifts[index].is_select
        if (gifts[index].type == 1) {
          if (that.data.gifts[index].is_hide == true) {
            gifts[index].is_hide = true
          } else {
            gifts[index].is_hide = false
          }
        }
      }
      that.typeClassify(f.type, f)
    }
    that.setData({
      gifts: gifts,
      giftslen: giftsLen,
      share_persons: share_persons,
      isMultiple: isMultiple,
      rebateNum: 0,
      showModal: true,
      recv_chance: recv_chance,
      recv_limit: recv_limit,
      callback: ''
    })
  }
  typeClassify = (type, f) => {
    switch (type) {
      case '1':
        f.image =
          'http://cdn.jisuapp.cn/static/webapp/images/share-gifts/coupon.png'
        f.path = '/eCommerce/pages/couponList/couponList'
        break
      case '2':
        f.image =
          'http://cdn.jisuapp.cn/static/webapp/images/share-gifts/integral.png'
        f.path = '/userCenter/pages/myIntegral/myIntegral'
        break
      case '3':
        f.image =
          'http://cdn.jisuapp.cn/static/webapp/images/share-gifts/balance.png'
        f.path = '/eCommerce/pages/balance/balance'
        break
      case '4':
      case '5':
        f.image =
          'http://cdn.jisuapp.cn/static/webapp/images/share-gifts/vip-card.png'
        f.path = '/eCommerce/pages/vipBenefits/vipBenefits'
        break
      case '6':
        f.image =
          'http://cdn.jisuapp.cn/static/webapp/images/share-gifts/collect.png'
        f.path = '/awardManagement/pages/collectStars/collectStars'
        break
      case '7':
        f.image =
          'http://cdn.jisuapp.cn/static/webapp/images/share-gifts/lucky-wheel.png'
        f.path = '/awardManagement/pages/luckyWheelDetail/luckyWheelDetail'
        break
      case '8':
        f.image =
          'http://cdn.jisuapp.cn/static/webapp/images/share-gifts/scratch.png'
        f.path = '/awardManagement/pages/scratch/scratch'
        break
      case '9':
        f.image =
          'http://cdn.jisuapp.cn/static/webapp/images/share-gifts/golden.png'
        f.path = '/awardManagement/pages/goldenEggs/goldenEggs'
        break
    }
    return f
  }
  showGifts = e => {
    let type = e.target['dataset']['type'];
    let index = e.target['dataset']['index'];
    let f = this.typeClassify(type, {})
    let path = f.path
    if (type == 4 || type == 5) {
      path = path + '?id=' + this.data.gifts[index].value
    }
    app.turnToPage(path)
  }
  recvReward = e => {
    var that = this,
      dataset = e.currentTarget.dataset,
      index = dataset.index,
      type = dataset.type,
      rebateNum = that.data.rebateNum,
      paramGifts = that.data.gifts[index] || 'all',
      gifts = that.data.gifts,
      giftsArr = []
    if (type != 'all') {
      paramGifts.times = 1
      giftsArr.push(paramGifts)
    } else {
      giftsArr = gifts
      if (rebateNum == 0) {
        return
      }
    }
    for (var i in gifts) {
      if (gifts[i].times >= 1 || gifts[i].is_select) {
        gifts[i].is_select = true
        gifts[i].giftsModal = 0
      } else {
        gifts[i].is_select = false
        gifts[i].giftsModal = 1
      }
    }
    that.setData({
      gifts: gifts
    })
    that.getRecv(giftsArr)
  }
  getRecv = giftsArr => {
    var that = this
    app.sendRequest({
      url: '/index.php?r=ShareGiftActivity/RecvRewards',
      method: 'POST',
      data: {
        rewards: giftsArr
      },
      success: res => {
        that.getRewards(false)
        let data = res.data
        let isAllRecv = true
        if (data && data.length) {
          for (let i = 0; i < data.length; i++) {
            if (!data[i].recv_result) {
              app.showModal({
                content: data[i].reason
              })
              isAllRecv = false
            }
          }
        }
        if (isAllRecv) {
          app.showToast({
            title: '领取成功',
            icon: 'none',
            duration: 3000
          })
        }
      }
    })
  }
  clickMinusButton = e => {
    this.changeGiftsNums('minus', e)
  }
  clickPlusButton = e => {
    this.changeGiftsNums('plus', e)
  }
  inputBuyCount = e => {
    this.changeGiftsNums('input', e)
  }
  changeGiftsNums = (type, e) => {
    var that = this,
      data = e.currentTarget.dataset,
      index = data.index,
      value = +e.target.value,
      currentGifts = that.data.gifts,
      rebateNum = that.data.rebateNum,
      total = 0,
      inputIndex = 0,
      targetGiftsCount =
        type == 'plus'
          ? currentGifts[index].times + 1
          : type == 'minus'
            ? currentGifts[index].times - 1
            : value,
      newdata = {}
    this.setData({
      is_select: false
    })
    if (type == 'input') {
      var re = /^[0-9]+$/
      if (!re.test(value)) {
        newdata['gifts[' + index + '].times'] = currentGifts[index].times
        that.setData(newdata)
        return
      }
      rebateNum = 0
      for (let i in currentGifts) {
        if (index != i) {
          rebateNum += currentGifts[i].times
        }
      }
      total = rebateNum + value
      if (total > that.data.recv_chance) {
        app.showToast({
          title: '已超过最大可领取奖励量',
          icon: 'none',
          duration: 1000
        })
        newdata['gifts[' + index + '].times'] = 1
        newdata['is_select'] = true
        newdata['rebateNum'] = rebateNum + 1
        this.setData(newdata)
        return
      }
      if (currentGifts[index].times >= currentGifts[index].stock) {
        app.showToast({
          title: '已超过最大库存量',
          icon: 'none',
          duration: 1000
        })
        newdata['gifts[' + index + '].times'] = currentGifts[index].times
        newdata['is_select'] = true
        newdata['rebateNum'] = rebateNum + 1
        this.setData(newdata)
        return
      }
      newdata['gifts[' + index + '].times'] = value
    }
    if (type == 'plus') {
      total = rebateNum + 1
      if (total > that.data.recv_chance) {
        app.showToast({
          title: '已超过最大可领取奖励量',
          icon: 'none',
          duration: 1000
        })
        this.setData({
          is_select: true,
          rebateNum: rebateNum
        })
        return
      }
      if (currentGifts[index].type == 1 && !currentGifts[index].stock) {
        app.showToast({
          title: '优惠券已领完',
          icon: 'none',
          duration: 1000
        })
        this.setData({
          is_select: true,
          rebateNum: rebateNum
        })
        return
      }
      if (
        (currentGifts[index].type == 4 || currentGifts[index].type == 5) &&
        targetGiftsCount > 1
      ) {
        app.showToast({
          title: '会员卡最多领取一次',
          icon: 'none',
          duration: 1000
        })
        this.setData({
          is_select: true,
          rebateNum: rebateNum
        })
        return
      }
      if (currentGifts[index].times >= currentGifts[index].stock) {
        app.showToast({
          title: '已超过最大库存量',
          icon: 'none',
          duration: 1000
        })
        this.setData({
          is_select: true,
          rebateNum: rebateNum
        })
        return
      }
      newdata['gifts[' + index + '].times'] = targetGiftsCount
    } else if (type == 'minus') {
      total = rebateNum - 1
      if (targetGiftsCount < 0) {
        return
      }
      rebateNum = rebateNum
      if (targetGiftsCount == 0) {
        newdata['gifts[' + index + '].times'] = 0
      } else {
        newdata['gifts[' + index + '].times'] = targetGiftsCount
      }
    }
    newdata['rebateNum'] = total
    that.setData(newdata)
  }

  render() {
    let {
      recv_limit,
      giftslen,
      recv_chance,
      isMultiple,
      surplus_times,
      type,
      share_persons,
      gifts,
      rebateNum,
      extra_rewards,
      immediately,
      times_limit,
      activity_rewards,
      extra_times_limit,
      description
    } = this.state

    return (
      <div className="official-page share-gifts">
        <TopNav title="分享有礼"/>
        <div id="shareGifts">
          <div className="banner-top">
            <div className="image-wrap">
              <img
                src="http://cdn.jisuapp.cn/static/webapp/images/share-gifts/banner-top.png"
                mode="aspectFill"
              />
            </div>
          </div>
          <div className="total-main-wrap">
            <div className="methods-wrap">
              <div className="share-gifts-title">
                {recv_limit == 0 || giftslen == 1 ? (
                  <React.Fragment>恭喜你获得以下奖励</React.Fragment>
                ) : (
                    recv_limit == 1 && (
                      <React.Fragment>
                        {recv_chance == 0
                          ? '奖励领取成功'
                          : !isMultiple
                            ? '以下奖励选一个'
                            : '以下奖励可选'}
                        {isMultiple && (
                          <div className="no-normal">
                            {recv_chance > 0 && (
                              <React.Fragment>
                                {type == 1 && (
                                  <React.Fragment>
                                    成功分享
                                <span style={convertLineStyleData('color:#FF7100;')}>
                                      {surplus_times}
                                    </span>
                                    次，剩余
                                <span style={convertLineStyleData('color:#FF7100;')}>
                                      {recv_chance}
                                    </span>
                                    次机会
                              </React.Fragment>
                                )}
                                {type == 2 && (
                                  <React.Fragment>
                                    成功分享
                                <span style={convertLineStyleData('color:#FF7100;')}>
                                      {share_persons}
                                    </span>
                                    位好友，剩余
                                <span style={convertLineStyleData('color:#FF7100;')}>
                                      {recv_chance}
                                    </span>
                                    次机会
                              </React.Fragment>
                                )}
                              </React.Fragment>
                            )}
                          </div>
                        )}
                      </React.Fragment>
                    )
                  )}
              </div>
              {!isMultiple ? (
                <div className="share-method-list">
                  {gifts && gifts.map((item, index) => {
                    return (
                      <React.Fragment key={index}>
                        {!item.is_hide && (
                          <div className="main-wrap">
                            <div>
                              <img src={item.image} />
                              <span className="mian-title">{item.title}</span>
                              {(recv_limit == 0 || gifts.length == 1) &&
                                item.already_times > 1 && (
                                  <span space="ensp">
                                    {'*' + item.already_times}
                                  </span>
                                )}
                            </div>
                            {((item.type == 4 || item.type == 5) &&
                              item.already_recv) ||
                              (item.type == 1 &&
                                !item.is_hide &&
                                item.stock == 0) ? (
                                <React.Fragment>
                                  <div
                                    className="showGifts"
                                    data-type={item.type}
                                    onClick={this.showGifts}
                                    data-index={index}
                                  >
                                    查看
                              </div>
                                </React.Fragment>
                              ) : (
                                <React.Fragment>
                                  {item.giftsModal == 1 ? (
                                    <React.Fragment>
                                      {!item.is_select && recv_chance > 0 ? (
                                        <div
                                          onClick={this.recvReward}
                                          className="getGifts no_select"
                                          data-type={item.type}
                                          data-index={index}
                                        >
                                          领取
                                    </div>
                                      ) : (
                                          <div
                                            className="getGifts select"
                                            data-type={item.type}
                                            data-index={index}
                                          >
                                            领取
                                    </div>
                                        )}
                                    </React.Fragment>
                                  ) : (
                                      <React.Fragment>
                                        <div
                                          className="getGifts"
                                          onClick={this.showGifts}
                                          data-index={index}
                                          data-type={item.type}
                                        >
                                          查看
                                  </div>
                                      </React.Fragment>
                                    )}
                                </React.Fragment>
                              )}
                          </div>
                        )}
                      </React.Fragment>
                    )
                  })}
                </div>
              ) : (
                  <div>
                    <div className="share-method-list">
                      {gifts.map((item, index) => {
                        return (
                          <React.Fragment key={index}>
                            {!item.is_hide && (
                              <div className="main-wrap">
                                <div>
                                  <img src={item.image} />
                                  <span className="mian-title">{item.title}</span>
                                  {recv_limit == 0 && item.already_times > 1 && (
                                    <span space="ensp">
                                      {'*' + item.already_times}
                                    </span>
                                  )}
                                </div>
                                {((item.type == 4 || item.type == 5) &&
                                  item.already_recv) ||
                                  (item.type == 1 &&
                                    !item.is_hide &&
                                    item.stock == 0) ? (
                                    <React.Fragment>
                                      <div
                                        className="showGifts"
                                        data-type={item.type}
                                        onClick={this.showGifts}
                                        data-index={index}
                                      >
                                        查看
                                </div>
                                    </React.Fragment>
                                  ) : (
                                    <React.Fragment>
                                      {recv_chance == 0 ? (
                                        <React.Fragment>
                                          {item.is_select ? (
                                            <div
                                              className="showGifts"
                                              data-type={item.type}
                                              onClick={this.showGifts}
                                              data-index={index}
                                            >
                                              查看
                                      </div>
                                          ) : (
                                              <div
                                                className="getGifts select"
                                                data-type={item.type}
                                                data-index={index}
                                              >
                                                领取
                                      </div>
                                            )}
                                        </React.Fragment>
                                      ) : (
                                          <React.Fragment>
                                            {recv_chance != 0 && (
                                              <div className="quantity">
                                                <label className="minus"></label>
                                                <input
                                                  className="pay-buy-count txt"
                                                  type="number"
                                                  value={item.times}
                                                  data-index={index}
                                                  onInput={this.inputBuyCount}
                                                />
                                                <label className="plus"></label>
                                                <div
                                                  className="response-area response-area-minus"
                                                  onClick={this.clickMinusButton}
                                                  data-index={index}
                                                ></div>
                                                <div
                                                  className="response-area response-area-plus isRelative"
                                                  onClick={this.clickPlusButton}
                                                  data-index={index}
                                                ></div>
                                              </div>
                                            )}
                                          </React.Fragment>
                                        )}
                                    </React.Fragment>
                                  )}
                              </div>
                            )}
                          </React.Fragment>
                        )
                      })}
                    </div>
                    {recv_chance != 0 && (
                      <React.Fragment>
                        <div style={convertLineStyleData('width:100%;padding-bottom:40rpx;background:#fff;')}>
                          <div
                            className={
                              'getGifts ' +
                              (rebateNum == 0 ? 'select' : 'no_select') +
                              ' multi-getGifts'
                            }
                            onClick={this.recvReward}
                            data-type="all"
                            data-index={index}
                          >
                            领取
                      </div>
                        </div>
                      </React.Fragment>
                    )}
                  </div>
                )}
            </div>
            {extra_rewards && extra_rewards.num >= 1 && immediately == 2 && (
              <div className="extra-wrap">
                <div className="share-gifts-title">拉新额外奖励</div>
                <div className="share-method-list">
                  <div className="main-wrap">
                    <div>
                      <img src={extra_rewards.image} />
                      <span className="mian-title">
                        {extra_rewards.reward_title}
                      </span>
                      {extra_rewards.num > 1 && (
                        <span space="ensp">{'*' + extra_rewards.num}</span>
                      )}
                    </div>
                    <div
                      className="showGifts"
                      data-type={extra_rewards.type}
                      onClick={this.showGifts}
                    >
                      查看
                  </div>
                  </div>
                </div>
              </div>
            )}
            {description && (
              <div className="toast-wrap">
                <div className="tips">分享说明</div>
                <div className="content">
                  <div>
                    分享奖励：
                  {gifts && gifts.map((item, index) => {
                      return (
                        <span key={index} style={convertLineStyleData('color:#ff7100;')}>
                          {item.title + (index == gifts.length - 1 ? '' : '、')}
                        </span>
                      )
                    })}
                    {recv_limit == 1 && gifts.length > 1
                      ? '(' + gifts.length + '选1)'
                      : ''}
                  </div>
                  <div>
                    {'奖励限制：每个用户' +
                      (times_limit.type == 2 ? '每天' : '') +
                      '有'}
                    <span>{times_limit.value}</span>次领取奖励机会
                </div>
                  {activity_rewards.length > 0 && (
                    <React.Fragment>
                      <div>
                        拉新额外奖励：<span>{activity_rewards[0].title}</span>
                      </div>
                      <div>
                        {'拉新奖励限制：每个用户' +
                          (extra_times_limit.type == 2 ? '每天' : '') +
                          '有'}
                        <span>{extra_times_limit.value}</span>次奖励机会
                    </div>
                    </React.Fragment>
                  )}
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/official-page/share-gifts/ShareGifts.jsx